// src/services/complaint.service.ts
import api from './api';

// =====================
// LODGE COMPLAINT
// =====================
export const lodgeComplaint = async (formData: FormData) => {
  const response = await api.post('/bcomplaint', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

// =====================
// GET MY COMPLAINTS
// =====================
export const getMyComplaints = async (params?: {
  page?: number;
  pageSize?: number;
  status?: string;
  search?: string;
}) => {
  const response = await api.get('/bcomplaint', { params });
  return response.data;
};

// =====================
// GET COMPLAINT DETAIL
// =====================
export const getComplaintDetail = async (id: string) => {
  const response = await api.get(`/bcomplaint/${id}`);
  return response.data;
};

// =====================
// ADD COMMENT
// =====================
export const addComment = async (id: string, text: string) => {
  const response = await api.post(`/bcomplaint/${id}/comments`, { text });
  return response.data;
};

// =====================
// UPLOAD EVIDENCE
// =====================
export const uploadEvidence = async (id: string, formData: FormData) => {
  const response = await api.post(`/bcomplaint/${id}/evidence`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

// =====================
// REOPEN COMPLAINT
// =====================
export const reopenComplaint = async (id: string, reason?: string) => {
  const response = await api.patch(`/bcomplaint/${id}/reopen`, { reason });
  return response.data;
};

// =====================
// ESCALATE COMPLAINT
// =====================
export const escalateComplaint = async (id: string, reason?: string) => {
  const response = await api.patch(`/bcomplaint/${id}/escalate`, { reason });
  return response.data;
};

export const downloadEvidence = async (complaintId: string, evidenceId: string) => {
  const response = await api.get(
    `/bcomplaint/${complaintId}/evidence/${evidenceId}/download`, 
    {
      responseType: 'blob', 
    }
  );
  return response.data; 
};

export const downloadAllEvidence = async (
  complaintId: string
) => {
  const response = await api.get(
    `/bcomplaint/${complaintId}/evidence/download-all`,
    {
      responseType: 'blob',
    }
  );

  return response.data;
};

